// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__vBPBH","footer":"ModalFilter_footer__2qiJP"};